import { useMemo, useState } from "react";

import {
  AnalysisHistoryDetailResponse,
  DatasetHistoryAnalysisItem
} from "@/types/analysisHistory";

import { DatasetCard } from "./DatasetCard";

interface AnalysisHistoryDatasetListProps {
  data: AnalysisHistoryDetailResponse;
}

export function AnalysisHistoryDatasetList({
  data
}: Readonly<AnalysisHistoryDatasetListProps>) {
  const datasets: DatasetHistoryAnalysisItem[] = data.datasets;
  const [expandedIds, setExpandedIds] = useState<string[]>([]);

  const allExpanded = useMemo(
    () => expandedIds.length === datasets.length && datasets.length > 0,
    [expandedIds, datasets.length]
  );

  const handleExpandCollapse = (datasetId: string) => {
    setExpandedIds((prev) =>
      prev.includes(datasetId)
        ? prev.filter((id) => id !== datasetId)
        : [...prev, datasetId]
    );
  };

  const handleExpandAll = (expand: boolean) => {
    setExpandedIds(expand ? datasets.map((d, idx) => d.id + idx) : []);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-txtHeading font-semibold text-[14px]">Datasets</h3>
        <button
          className="text-primary-teal text-xs font-semibold hover:underline"
          onClick={() => handleExpandAll(!allExpanded)}
        >
          {allExpanded ? "Collapse All" : "Expand All"}
        </button>
      </div>

      <div className="grid grid-cols-1 hd:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-7 items-start gap-4">
        {datasets.map((item, idx) => (
          <DatasetCard
            key={item.id + idx}
            data={item}
            expanded={expandedIds.includes(item.id + idx)}
            handleExpandCollapse={() => handleExpandCollapse(item.id + idx)}
          />
        ))}
      </div>
    </div>
  );
}
